import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 84D958BE-5145-4490-BA8F-D00E6870CC9D
 * name shuffle-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shuffle-variant.svg
 * tags
 * - Arrow 
 */
export const ShuffleVariantIcon = createSvgIcon(<><path d="M17,3L22.25,7.5L17,12L22.25,16.5L17,21V18H14.26L11.44,15.18L13.56,13.06L15.5,15H17V12L17,9H15.5L6.5,18H2V15H5.26L14.26,6H17V3M2,6H6.5L9.32,8.82L7.2,10.94L5.26,9H2V6Z" /></>, 'ShuffleVariantIcon');
export default ShuffleVariantIcon